import * as React from 'react'

// Components
import Svg from './..'

const Dog = (props) => {
  return (
    <Svg fill="none" viewBox="0 0 13 13" {...props}>
      <path
        d="M9.84 4.342h2.503L13 2.654l-.653-.615-1.466.012-1.04-.947H8.234L9.123 0 7.307.443l-.525 2.013c-.282.99-.89 2.31-1.374 3.068-1.41 2.204-2.764 3.67-2.972 5.22-.92-.232-2.273-.936-2.325-3.062 0 0-.86 3.281 2.199 4.257-.052.664-.048 1.061-.048 1.061h6.846c-.054-.396-.423-.602-.67-.697l-.102-1.873-.232-.75.508-.107L9.488 13h2.833c-.084-.604-.898-.765-.898-.765h-.56l-.779-2.804-.245-1.228-.767-3.05.401-1.007z"
        fill="#3ce967"
      />
    </Svg>
  )
}

export default Dog
